import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { SectionData } from '../../../editor-container/editor-model';
import { Observable } from 'rxjs';
import { distinctUntilChanged, take, tap } from 'rxjs/operators';
import { ContentElement } from '@urbannex/storethemes';

export interface SectionState{
  sectionId:string;
  sectionData:SectionData; 
  color?:string; 
}

@Injectable({
  providedIn: 'root'
})
export class SectionEditorStoreService extends ComponentStore<SectionState>{

  constructor() {
    super({
      sectionId: '',
      sectionData: undefined
    })
   }
   //Initial state
   /* readonly setSectionData = this.updater<SectionData>((state, sectionData) => ({
    ...state,
    sectionData
  })); */
   //updaters
   readonly updateSectionData = this.updater((state:SectionState,sectionData:SectionData) => {
    console.log("Updating section data - store",sectionData);
    return{
      ...state,
      sectionData:{ ...sectionData }
    }
   })
   readonly updateColor = this.updater((state:SectionState,color:string) => {
    return{
      ...state,
      color:color
    }
   })
   readonly color$ = this.select(state => state.color);
   readonly title$ = this.select(state => state.sectionData.title)
   readonly sectionData$ = this.select(state => state.sectionData).pipe(distinctUntilChanged())

   //Effects

   readonly setColor = this.effect((color$:Observable<string>) => {
    return color$.pipe(
      tap((color:string) => {
        console.log(color);
        this.updateColor(color)
        this.title$.subscribe((title:ContentElement) => {
          title.color = color;
          this.sectionData$.pipe(take(1)).subscribe(sectionData => {
            sectionData = {...sectionData,title};
            this.updateSectionData(sectionData);
          })          
        })
      })
    )
   })
   readonly updateBackground = this.effect((background$:Observable<string>) => {
    return background$.pipe(
      tap((background:string) => {
        this.title$.subscribe((title:ContentElement) => {
          title.background = background;
          this.sectionData$.pipe(take(1)).subscribe(sectionData => {
            sectionData = {...sectionData,title};
            this.updateSectionData(sectionData);
          })          
        })
      })
    )
   })
   readonly updateMarginBottom = this.effect((marginBottom$:Observable<number>) => {
    return marginBottom$.pipe(
      tap((marginBottom:number) => {
        console.log(marginBottom);
        this.sectionData$.subscribe(sectionData => {
          sectionData.marginBottom = marginBottom;
          this.updateSectionData(sectionData);
        })
      })
    )
   })

   readonly updateTitle = this.effect((title$:Observable<ContentElement>) => {
    console.log("Title updated")
    return title$.pipe(
      tap((title:ContentElement) => {
        this.sectionData$.pipe(take(1)).subscribe(sectionData => {
          sectionData = {...sectionData,title};
          this.updateSectionData(sectionData);
        })
      })
    )
   })
  
}
